// extracted by mini-css-extract-plugin
module.exports = {"base":"Trending--base--DpdQQ","title":"Trending--title--3emjL"};